var Backbone = bookedby.deps != null ? bookedby.deps.Backbone : global.Backbone;
var $ = bookedby.deps != null ? bookedby.deps.$ : global.$;
var _ = bookedby.deps != null ? bookedby.deps._ : global._;

var SelectorView = require('./selector');

var GuestsSelectorView = SelectorView.extend({
  template: 'components.guestSelector',
  events: {
    'click .select-addon': 'focusOnInputWithAddon',
    'change .select-guest': 'valueChanged',
    'focus .select-guest': 'showList',
    'click .select-guest': 'showList',
    'blur .select-guest': 'showList',
    'focusout .select-guest': 'hideAllLists',
    'click .select-guest-list li': 'selectGuest',
    'keydown .select-guest': 'keyActions'
  },
  initialize: function(options) {
    options = options || {};
    SelectorView.prototype.initialize.apply(this, [options]);

    this.bindings = {};
    if (this.model.get(this.boundProperty + '_invalid') !== undefined) {
      this.bindings['.form-group'] = "classes:{'has-error':" + this.boundProperty + "_invalid}";
      this.bindings['.help-block'] = "text:" + this.boundProperty + "_error,toggle:" + this.boundProperty + "_invalid";
    }

    this.eventsReady = false;
    this.guests = this.computeGuests();
  },

  computeGuests: function() {
    var guests = [];

    for (var i = 0 ; i < bookedby.staticData.storeGroupSettings.maxNumberOfGuests ; i++) {
      guests[i] = {
        guests: i,
        label: (i == 0) ? 'Just Me' : 'Me & ' + i + ' Guest' + (i > 1 ? 's' : '')
      };
    }

    return guests;
  },

  beforeRender: function() {
    if (!this.eventsReady) {
      this.model.on('change:' + this.boundProperty, this.modelChanged, this);
      this.eventsReady = true;
    }
  },

  afterRender: function() {
    this.applyBindings();
    this.$input = this.$el.find('.select-guest');
    this.$listId = 'selectGuestList';
    this.modelChanged();
  },

  cleanup: function() {
    this.model.off('change:' + this.boundProperty, this.modelChanged, this);
    this.removeBindings();
    this.eventsReady = false;
  },

  serialize: function() {
    return {
      guests: this.guests
    };
  },

  valueChanged: function() {
    var selectedId = parseInt(this.$input.attr('data-id'));

    if (selectedId == -1) {
      this.model.set(this.boundProperty, -1);
    } else {
      this.model.set(this.boundProperty, selectedId);
    }
  },

  modelChanged: function() {
    var selectedItem = parseInt(this.model.get(this.boundProperty));

    if (selectedItem == -1) {
      this.$input.val('');
    } else {
      this.$input.val(this.guests[selectedItem].label);
      this.$input.attr('data-id', selectedItem);
    }
  },

  selectGuest: function(e) {
    e.preventDefault();
    var selectedLi = $(e.currentTarget);
    var value = selectedLi.data('id');

    o = {
      id: value,
      name: selectedLi.find('span').text()
    };

    this.selectItem(o);
  },

  navigateListWithArrowKeys: function(key, keys) {
    var listId = this.$listId;
    switch(key) {
      case keys.up:
        this.navigateList(listId, 'up');
        break;
      case keys.down:
        this.navigateList(listId, 'down');
        break;
      case keys.tab:
        this.navigateList(listId, 'down');
        break;
    }
  },
});

module.exports = GuestsSelectorView;
